import Ajv from 'ajv'
import { SchemaValidateFunction, DataValidationCxt } from 'ajv/dist/types'
import moment from 'moment'


// exported for testing
export const afterDateValidate: SchemaValidateFunction = (schema: any, data: any, parentSchema: any, dataCxt?: DataValidationCxt): boolean => {
    if (parentSchema.afterDateDistance === undefined) {
        throw new Error('keyword "afterDateDistance" is absent')
    }

    const format = parentSchema.format
    const value = moment(data)
    let from = moment(schema).startOf('day')
    const [dist, units] = parentSchema.afterDateDistance.split(' ')

    if (format === 'date') {
        from = from.startOf('day') // ignore time of day if we compare a date only
    }

    const diff = value.diff(from, units)
    if (!(diff <= Number(dist) && diff >= 0)) {
        afterDateValidate.errors = [{
            keyword: 'afterDate',
            instancePath: dataCxt?.instancePath || '',
            schemaPath: '',
            params: {
                limit: from.format(),
                distance: dist,
                units
            }
        }]
        return false
    }

    return true
}


/* v8 ignore start */
export const afterDateKeyword = (ajv: Ajv) => {
    ajv.addKeyword({
        keyword: 'afterDate',
        $data: true,
        validate: afterDateValidate,
        dependencies: ['format', 'afterDateDistance'],
        errors: 'full',
        metaSchema: {
            anyOf: [
                { type: 'string' },
                {
                    type: 'object',
                    required: ['$data'],
                    properties: {
                        $data: {
                            type: 'string',
                            anyOf: [
                                { format: 'relative-json-pointer' },
                                { format: 'json-pointer' }
                            ]
                        }
                    },
                    additionalProperties: false
                }
            ]
        }
    })

    ajv.addKeyword({
        keyword: 'afterDateDistance',
        dependencies: ['afterDate'],
        metaSchema: {
            type: 'string',
            pattern: '^\\d+ (days|months|years)'
        }
    })
}
/* v8 ignore end */
